import { Col, Row, ELanguage, Popup } from '@microfrontends/react-components'
import React, { useContext, useState } from 'react'
import Link from 'next/link'
import { ICareerPathByIndustry } from '../types'
import CareerView from './CareerView'
import { ContentContainer, ContentWrapper } from './CareerPathByIndustry.css'
import AppContext from '../../../../context/AppContext'

interface IProps {
	industries: ICareerPathByIndustry[]
}

const BASE_URL = process.env.VNW_BASE_URL

const LinkWrapper: React.FC<{
	disabled?: boolean
	children: React.ReactNode
	languageCode: ELanguage
	industry: ICareerPathByIndustry
}> = ({ children, disabled, languageCode, industry }) => {
	if (disabled) {
		return React.cloneElement(children as React.ReactElement<any>, {
			href: undefined
		})
	}
	return (
		<Link
			href={{
				pathname:
					languageCode === ELanguage.VI
						? '/lo-trinh-su-nghiep/[...career]'
						: '/career-path/[...career]',
				query: {
					career: [
						industry.levelAlias,
						industry.industryId.toString()
					]
				}
			}}
			passHref
		>
			{children}
		</Link>
	)
}

const CareerPathByIndustry: React.FC<IProps> = ({ industries }) => {
	const { languageCode = ELanguage.VI } = useContext(AppContext)
	const [currentIndustry, setCurrentIndustry] = useState<
		| (ICareerPathByIndustry & {
				index: number
		  })
		| null
	>(null)
	const [showPopup, setShowPopup] = useState(false)

	const baseUrl =
		BASE_URL + languageCode === ELanguage.VI
			? '/lo-trinh-su-nghiep'
			: '/career-path'

	const handleClickItem = (
		industry: ICareerPathByIndustry,
		index: number
	) => {
		if (industry.items === null || industry.items.length === 0) {
			return
		}
		setCurrentIndustry({ ...industry, index })
		setShowPopup(true)
	}

	const handleClearCurrentIndustry = () => {
		setCurrentIndustry(null)
	}

	return (
		<>
			<Row justify='center' gutter={[0, 16]}>
				{industries.map((industry, index) => {
					return (
						<Col
							key={industry.levelAlias}
							xs={12}
							sm={6}
							onClick={() => handleClickItem(industry, index)}
						>
							<LinkWrapper
								industry={industry}
								languageCode={languageCode}
								disabled={industry.items !== null}
							>
								<CareerView
									icon={industry.icon}
									isActive={
										currentIndustry?.levelAlias ===
										industry.levelAlias
									}
									industryName={industry.industryName}
									levelName={industry.industryNameEn}
								/>
							</LinkWrapper>
						</Col>
					)
				})}
			</Row>
			<Popup
				isShow={showPopup}
				lang={ELanguage.VI}
				onClose={() => setShowPopup(false)}
				onClickOutside={() => setShowPopup(false)}
				styleOption={{ size: 'md' }}
				text={{
					header: currentIndustry?.industryName
				}}
				customActionPopup={{
					enable: true,
					delayTime: 100,
					actionCustomPopupAfterShow: handleClearCurrentIndustry
				}}
				custom={{
					footer: <></>,
					withDefaultBody: true
				}}
			>
				<ContentContainer>
					<ContentWrapper gutter={[24, 16]}>
						{currentIndustry
							? currentIndustry.items.map((industry) => {
									return (
										<Col
											xs={12}
											sm={8}
											key={industry.industryName}
										>
											<LinkWrapper
												industry={industry}
												languageCode={languageCode}
												disabled={
													industry.items !== null
												}
											>
												<CareerView
													icon={industry.icon}
													href={
														baseUrl +
														`/${industry.levelAlias}/${industry.industryId}`
													}
													industryName={
														industry.industryName
													}
													levelName={
														industry.industryNameEn
													}
												/>
											</LinkWrapper>
										</Col>
									)
							  })
							: null}
					</ContentWrapper>
				</ContentContainer>
			</Popup>
		</>
	)
}

export default CareerPathByIndustry
